import React from "react";
import { TableRow, TableSortLabel, TableCell } from "@mui/material";
import { styled } from "@mui/material/styles";
import { BannerData } from "types/models/master/MasterApp";

interface TableHeadingProps {
  orderBy: string;
  order: "asc" | "desc";
  onSort: (property: keyof BannerData) => void;
}

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  width: 200,
  maxWidth: 180,
  minWidth: 160,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  padding: 8,
}));

const TableHeading: React.FC<TableHeadingProps> = ({ orderBy, order, onSort }) => {
  const createSortHandler = (property: keyof BannerData) => () => {
    onSort(property);
  };

  return (
    <TableRow>
      <StyledTableCell align="left">Action</StyledTableCell>

      <StyledTableCell
        align="left"
        sortDirection={orderBy === "bannerType" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "bannerType"}
          direction={order}
          onClick={createSortHandler("bannerType")}
        >
          Manage Banner
        </TableSortLabel>
      </StyledTableCell>

      <StyledTableCell
        align="left"
        sortDirection={orderBy === "title" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "title"}
          direction={order}
          onClick={createSortHandler("title")}
        >
          Title
        </TableSortLabel>
      </StyledTableCell>

      <StyledTableCell align="left">Image</StyledTableCell>

      <StyledTableCell
        align="left"
        sortDirection={orderBy === "index" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "index"}
          direction={order}
          onClick={createSortHandler("index")}
        >
          Index No
        </TableSortLabel>
      </StyledTableCell>

      <StyledTableCell
        align="left"
        sortDirection={orderBy === "active" ? order : false}
      >
        <TableSortLabel
          active={orderBy === "active"}
          direction={order}
          onClick={createSortHandler("active")}
        >
          Status
        </TableSortLabel>
      </StyledTableCell>
    </TableRow>
  );
};

export default TableHeading;
